import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="bg-gradient-to-r from-yellow-500 to-amber-500 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Crea Tu Experiencia con Agente 360 Tours
          </h2>
          <p className="text-xl text-gray-800 mb-8">
            Comienza a planificar tu tour formativo hoy y acelera tu carrera como agente FIFA.
          </p>
          <Button
            onClick={() => navigate("/consulta")}
            size="lg"
            className="bg-gray-900 hover:bg-gray-800 text-white font-bold text-lg px-10 py-7 shadow-2xl transition-all duration-300 hover:scale-105"
          >
            Reserva Tu Tour
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_3ea62174-d58f-4d0c-8b73-d8433d550e0e/artifacts/1goande0_IMG_1273.png"
              alt="Agente 360"
              className="h-16 w-auto mb-6"
            />
            <p className="text-gray-400 leading-relaxed">
              Tours formativos exclusivos para estudiantes de Agente 360. Más de 10 años formando agentes de fútbol con experiencias inmersivas en clubes de élite europeos.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-yellow-500">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Servicios
                </a>
              </li>
              <li>
                <a href="#destinos" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Tours
                </a>
              </li>
              <li>
                <a href="#testimonios" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Testimonios
                </a>
              </li>
              <li>
                <button
                  onClick={() => navigate("/consulta")}
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  Reservar
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-yellow-500">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400">
                <Mail className="h-5 w-5 mr-3 text-yellow-500" />
                tours@agente360.com
              </li>
              <li className="flex items-center text-gray-400">
                <Phone className="h-5 w-5 mr-3 text-yellow-500" />
                +34 123 456 789
              </li>
              <li className="flex items-start text-gray-400">
                <MapPin className="h-5 w-5 mr-3 mt-1 text-yellow-500" />
                <span>Madrid, España</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>© 2025 Agente 360 Tours. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
